<template>
  <li>
      <folder-item :folder="folder" :folderName="folderName" @toggle="toggle" @select="selectThisFolder"
      :isExpanded="expanded" :folderType="folderType" :selectedType="selectedType" :selectedFolder="selectedFolder"
      :showExpander="showExpander" :hasChildren="hasChildren"/>
      <div ref="children" :class="[folder.parent !== null ? 'childlist' : '']">
          <div ref="measure">
              <ul v-if="hasChildren">
                  <folderTree v-for="name in sortedChildren" :key="name"
                              :folder="folder.children[name]" :folderName="name"
                              :folderType="folderType" :selectedType="selectedType" :selectedFolder="selectedFolder"
                              @resize="childrenResized"
                              @select="$emit('select', $event)">
                  </folderTree>
              </ul>
          </div>
      </div>
  </li>
</template>

<script>
import FolderTree from '@/components/folderTree';
import FolderItem from '@/components/folderItem';
import FolderSorter from '../helpers/folderSorting';

export default {
  name: 'folderTree',
  components: { FolderTree, FolderItem },
  data: function() {
    return {
      expanded: false,
      childHeight: 0
    };
  },
  props: {
    folder: Object,
    folderName: String,
    showExpander: {
      type: Boolean,
      default: true
    },
    folderType: {
      type: String,
      default: ''
    },
    selectedType: String,
    selectedFolder: Number
  },
  watch: {
    hasChildren(newVal) {
      if (!newVal) {
        if (this.$refs.children.style.height !== 0) {
          this.$refs.children.style.height = 0;
          this.$emit('resize', -this.childHeight);
        }
      }
    }
  },
  methods: {
    toggle(doToggle = true) {
      if ((this.expandLocked(this.folder)) && (this.expanded)) {
        return;
      }
      if (this.hasChildren && this.showExpander) {
        if (doToggle) {
          this.expanded = !this.expanded;
        }

        if (this.expanded) {
          this.childHeight = this.$refs.measure.clientHeight;
          this.$refs.children.style.height = this.childHeight + 'px';
          this.$emit('resize', this.$refs.measure.clientHeight);
        } else {
          this.$refs.children.style.height = '0';
          this.$emit('resize', -this.childHeight);
        }
      }
    },
    childrenResized(size) {
      if (this.folder.parent === null) {
        return;
      }
      this.$nextTick(() => {
        this.childHeight += size;
        this.$refs.children.style.height = this.childHeight + 'px';
        this.$emit('resize', size);
      });
    },
    selectThisFolder(evt) {
      this.$emit('select', evt);
    },
    expandLocked(folder) {
      if (this.selectedType === '') {
        if (folder.selected) {
          return true;
        }
        for (const c in folder.children) {
          if (this.expandLocked(folder.children[c])) {
            return true;
          }
        }
      }
      return false;
    }
  },
  computed: {
    hasChildren() {
      return Object.keys(this.folder.children).length > 0;
    },
    isExpanded() {
      return this.show || this.folder.parent === null;
    },
    sortedChildren() {
      return FolderSorter(this.folder.children, this.folder.parent === null);
    }
  }
};
</script>

<style scoped lang="scss">
    @import '../assets/bootstrap-style.scss';

ul {
    padding-left: 5px;
    list-style: none;
}

.childlist {
    height: 0px;
    overflow: hidden;
    transition: height 0.5s;
}
</style>
